<span class="icon-sm">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" version="1.1" x="0px" y="0px" width="28px" height="28px" viewBox="0 0 28 28" enable-background="new 0 0 28 28" xml:space="preserve">
        <defs/>
        <g id="Edit_1_">
            <circle fill="#024953" cx="14" cy="14" r="14"/>
            <path fill="#FFFFFF" d="M16.9 8.1l3.1 3.1 -10 10L6.1 22 6 21.9 6.9 18 16.9 8.1zM8.9 18l1 1 7.9-7.9 -1-1L8.9 18zM21.5 7.3l-0.8-0.8c-1.1-1.1-2.3 0-2.3 0l-0.7 0.7 3.1 3.1 0.7-0.7C21.5 9.6 22.6 8.4 21.5 7.3z"/>
        </g>
    </svg>
</span>
